<template>
  <ValidationProvider v-slot="{ errors }" :name="`'${label}'`" :rules="rules" :vid="vid">
    <v-select
        item-value="stepCount"
        item-text="stepValue"
        :items="items"
        :value="current"
        :error-messages="errors"
        :readonly="readonly"
        :clearable="clearable && !readonly"
        :prepend-icon="prependIcon"
        return-object
        :label="label"
        eager
        :hide-details="hideDetails"
        :dense="dense"
        @change="change">
      <template v-slot:prepend-inner>
        <v-icon
            v-if="required"
            small
            left
            :color="requiredColor">
          *
        </v-icon>
      </template>
    </v-select>
  </ValidationProvider>
</template>

<script>
  export default {
    props: {
      value: {
        type: [String, Number],
        required: true
      },
      step: {
        type: [String, Number],
        required: true
      },
      maxStepCount: {
        type: Number,
        required: true
      },
      addZero: {
        type: Boolean,
        default: false
      },
      hideDetails: {
        type: [String, Boolean],
        default: null
      },
      rules: [String, Object],
      prependIcon: {
        type: String,
        default: ''
      },
      requiredColor: {
        type: String,
        default: 'requiredfield'
      },
      label: {
        type: String,
        default: ''
      },
      startPremiumLabel: {
        type: String,
        default: ''
      },
      readonly: {
        type: Boolean,
        default: false
      },
      clearable: {
        type: Boolean,
        default: false
      },
      dense: {
        type: Boolean,
        default: false
      },
      vid: {
        type: String,
        default: null
      }
    },
    computed: {
      items () {
        const vm = this

        const steps = new Array(vm.maxStepCount)
        for (let i = 0; i < steps.length; i++) {
          const stepCount = Number.parseInt(i + 1)
          let stepDescription
          const modulo = stepCount % 10

          if (stepCount >= 11 && stepCount < 15) {
            stepDescription = vm.$t('шагов')
          } else if (modulo === 1) {
            stepDescription = stepCount === 1
              ? vm.$t('step')
              : vm.$t('steps')
          } else if (modulo > 1 && modulo < 5) {
            stepDescription = vm.$t('шага')
          } else if (modulo >= 5 || modulo === 0) {
            stepDescription = vm.$t('шагов')
          }

          steps[i] = {
            stepCount,
            stepValue: `${(stepCount * vm.step).toFixed(2)} (${stepCount} ${stepDescription})`
          }
        }
        if (vm.addZero) {
          steps.unshift({
            stepCount: 0,
            stepValue: this.startPremiumLabel
          })
        }
        return steps
      },
      required () {
        if (!this.rules) {
          return false
        }
        return (this.rules.hasOwnProperty('required') && this.rules.required) ||
          (!this.rules.hasOwnProperty('required') &&
            !!this.rules.length &&
            this.rules.includes('required'))
      },
      current () {
        if (this.value || this.value === 0) {
          return this.items.find(i => i.stepCount === this.value) || null
        }

        return null
      }
    },
    methods: {
      change: function (item) {
        if (this.value !== item?.stepCount) {
          this.$emit('change', item && (item.stepCount || item.stepCount === 0)
            ? item.stepCount
            : null)
        }

        this.$emit('input', item && (item.stepCount || item.stepCount === 0)
          ? item.stepCount
          : null)
      }
    }
  }
</script>
